import { createContext, useContext, useMemo } from "react";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  // Preshh sells in euros only — prices are shown and charged in EUR; customers
  // convert on their side. No multi-currency switcher.
  const value = useMemo(() => {
    const format = (eur) => {
      try { return new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(Number(eur) || 0); }
      catch { return `${(Number(eur) || 0).toFixed(2)} €`; }
    };
    return {
      currency: "EUR",
      setCurrency: () => {},
      currencies: ["EUR"],
      rates: { EUR: 1 },
      asOf: null,
      ready: true,
      convert: (eur) => Math.round((Number(eur) || 0) * 100) / 100,
      format,
      formatAmount: format,
    };
  }, []);

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export const useCurrency = () => useContext(CurrencyContext);
